"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = __importDefault(require("./WriterLabel/index"));
const mobx_react_1 = require("mobx-react");
const WriterLabels = (props) => {
    const { linkedWriters } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, linkedWriters.map((linkedWriter, index) => (react_1.default.createElement(index_1.default, Object.assign({ key: index, linkedWriter: linkedWriter }, props))))));
};
exports.default = (0, mobx_react_1.observer)(WriterLabels);
